export const REDUCER_KEY = 'adfortmats';
